module.exports = __webpack_public_path__ + "img/receipt-invoice-stamp.cc474e9a.png";